import { render, staticRenderFns } from "./About.vue?vue&type=template&id=12a44dea&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=12a44dea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a44dea",
  null
  
)

export default component.exports